import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'
import { productSearchResult } from "../src/product_search_result"

export default class extends Controller {
  static values = {
    searchUrl: String,
    brandId: String,
    productId: String,
    groupId: String,
    groupOnly: Boolean
  }

  connect() {
    this.initializeTomSelect()
  }

  initializeTomSelect() {
    const searchUrl = this.buildSearchUrl()

    this.tomSelect = new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'text',
      searchField: [],
      diacritics: true,
      preload: true,
      closeAfterSelect: true,
      loadThrottle: 200,
      maxItems: 1,
      onChange: () => {
        document.activeElement.blur()
      },
      load: (query, callback) => {
        this.tomSelect.clearOptions()

        const url = searchUrl + encodeURIComponent(query)

        fetch(url)
          .then(response => response.json())
          .then(json => callback(json))
          .catch(() => callback())
      },
      render: {
        option: (item) => productSearchResult(item.text, item.heading, item.thumbnail_url, item.variant_type),
        item: (item) => productSearchResult(item.text, item.heading, item.thumbnail_url, item.variant_type)
      }
    })
  }

  buildSearchUrl() {
    // If a custom search URL is provided, use it
    if (this.hasSearchUrlValue) {
      return this.searchUrlValue
    }

    // Build search URL for product version selection (brand + exclude product)
    if (this.hasBrandIdValue && this.hasProductIdValue) {
      return `/search/products_search.json?search[brand_id]=${this.brandIdValue}&search[exclude_product_id]=${this.productIdValue}&search[term]=`
    }

    // Build search URL for product group selection (brand + exclude group)
    if (this.hasBrandIdValue && this.hasGroupIdValue && this.groupOnlyValue) {
      return `/search/products_search.json?search[brand_id]=${this.brandIdValue}&search[group_only]=true&search[exclude_group_id]=${this.groupIdValue}&search[term]=`
    }

    // Default: simple product search
    return '/search/products_search.json?search[term]='
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
